import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  site: "OSCR · Odisha Steel City Runners",
  desc: "Odisha Steel City Runners (OSCR) — born in Rourkela, built for all of Odisha. Join in-person events and virtual challenges led by 2× Guinness World Record holder Sumit Kumar Singh.",
};

export default function SEO({ title, description, path }) {
  const fullTitle = title ? `${title} · OSCR` : DEFAULTS.site;
  const desc = description || DEFAULTS.desc;
  const url = `https://challenge-runners.emergent.host${path || ""}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
